import { render } from "./LocationSelect.vue?vue&type=template&id=2a24bdd9"
import script from "./LocationSelect.vue?vue&type=script&lang=js"
export * from "./LocationSelect.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__